import React from 'react';
import clsx from 'clsx';

import './plan-card.scss';

const PlanCard = ({
  price,
  id,
  plan,
  projects,
  savings,
  period,
  selectedPlan,
  currentPlanProjects,
  currentInterval,
  onSelect,
  disabled,
}) => {
  const isSelected = plan.weddings === currentPlanProjects && plan.renew === currentInterval;
  const { includedSeats } = plan || {};
  const buttonName = () => {
    if (isSelected) {
      return 'Your plan';
    };
    return selectedPlan?.code === id ? 'Selected' : 'Select';
  };

  return (
    <div
      className={clsx('plan-card', isSelected && 'selected')}
      id={id}
    >
      <div className="plan-card__projects">
        {!projects ? (
          <>Sales<br />Essentials</>
        ) : (
          <>{projects} <br /> projects</>
        )}
        {includedSeats ? (
          <div className="plan-card__included-seats">
            ({includedSeats} AP Connect Seats)
          </div>
        ) : (
          <div className="plan-card__price-spacing"/>
        )}
      </div>
      <div className="plan-card__price price">
        {price} <span className="plan-card__price-label">{period}</span>
      </div>
      {savings && (
        <div className="plan-card__savings">
          {savings}
        </div>
      )}
      <button
        className={clsx('button', 'plan-card__button', { disabled })}
        onClick={() => !disabled && onSelect({ plan })}
        disabled={disabled}
      >
        {buttonName()}
      </button>
    </div>
  );
 };

 export default PlanCard;
